<template>
  <v-dialog v-model="dialog" max-width="600px" v-if="hasCreateAccess">
    <v-form v-model="validForm">
      <v-card>
        <v-card-title>
          <span class="headline" v-text="item.id ? 'Update LTP' : 'Add LTP'"></span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md py-0>
            <v-layout wrap>
              <v-flex xs12 sm6 v-if="item.id">
                <v-text-field readonly v-model="item.id" label="LTP No."></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field :rules="fNameRules" counter="50" v-model="item.title" label="Full Name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field :rules="v_rules.mobileRequired" mask="#### ### ###" counter="10" v-model="item.mobile" label="Mobile"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <autocomplete :rules="v_rules.required" v-model="item.id_type" :items="idCardTypes" label="ID Type" />
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field :rules="v_rules.required" counter="20" v-model="item.id_number" label="ID Number"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field :rules="v_rules.email" counter="50" v-model="item.email" label="Email"></v-text-field>
              </v-flex>
              <!-- <v-flex xs12 sm6 md6 v-if="!item.id">
                <v-text-field :rules="passwordRules" counter="20" prepend-icon="lock" :append-icon="showPasswords ? 'visibility_off' : 'visibility'" :type="showPasswords ? 'text' : 'password'" v-model="item.password" label="Password" @click:append="showPasswords = !showPasswords"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6 v-if="!item.id">
                <v-text-field :rules="passwordRules" counter="20" prepend-icon="lock" :type="showPasswords ? 'text' : 'password'" v-model="item.password1" label="Re-enter Password"></v-text-field>
              </v-flex> -->
              <v-flex xs12 sm6>
                <v-text-field counter="100" :rules="v_rules.required" v-model="item.address1" label="Address 1"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field counter="100" v-model="item.address2" label="Address 2"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <autocomplete :rules="v_rules.required" v-model="item.country" :items="countries" label="Country" search-key="country" />
              </v-flex>
              <v-flex xs12 sm6>
                <autocomplete :rules="v_rules.required" v-model="item.state" :items="states" label="State" search-key="state" />
              </v-flex>
              <v-flex xs12 sm6>
                <autocomplete :rules="v_rules.required" v-model="item.city" :items="cities" label="City" search-key="city" />
              </v-flex>
              <v-flex xs12 pt-3>
                <div class="title">Bank Account Details</div>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field :rules="v_rules.required" counter="100" v-model="item.bank_name" label="Bank Name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field :rules="v_rules.required" counter="150" v-model="item.branch_name" label="Branch Name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field :rules="v_rules.required" counter="100" v-model="item.account_holder" label="Account Holder"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field :rules="accountNumberRules" counter="16" v-model="item.account_number" label="Account Number"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field :rules="ifscRules" counter="11" maxlength="11" v-model="item.ifsc_code" label="IFSC Code"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat :disabled="processing" @click.native="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="upsertItem" v-text="item.id ? 'Update' : 'Save'"></v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>

  export default {
    name: 'AgentCreate',
    props: {
      editingItem: null,
      active: false
    },

    data () {
      return {
        dialog: false,
        validForm: false,
        processing: false,
        showPasswords: false,
        idCardTypes: [],
        states: [],
        cities: [],
        item: {},
        defaultItem: {
          id: "",
          title: "",
          city: "",
          state: "",
          country: this.getDefault('country'),
          // code: "",
          id_type: "",
          id_number: "",
          bank_name: "",
          branch_name: "",
          account_holder: "",
          account_number: "",
          ifsc_code: "",
          mobile: "",
          email: "",
          is_active: false,
          is_deleted: false,
          address1: "",
          address2: ""
        },
        fNameRules: [
            v => !!v || 'Name is required',
            v => v && v.trim().length >= 4 || 'Must be more than 3 characters',
            v => v && v.trim().length <= 50 || 'Maximum 50 characters allowed'
        ],
        passwordRules: [
            v => !!v || 'Password is required',
            v => v && v.trim().length >= 5 || 'Must be more than 4 characters',
            v => v && v.trim().length <= 20 || 'Maximum 20 characters allowed'
        ],
        codeRules: [
            v => !!v || 'LTP No. is required',
            v => v && v.length >= 4 || 'Must be more than 3 characters',
            v => v && v.length <= 20 || 'Maximum 20 characters allowed'
        ],
        accountNumberRules: [
            v => !!v || 'Account Number is required',
            v => /^([0-9]{9,18})$/.test(v) || 'Account Number must be valid'
        ],
        ifscRules: [
            v => !!v || 'IFSC Code is required',
            v => /^(([A-Z]{4})0([A-Z0-9]{6}))$/.test(v) || 'IFSC Code must be valid'
        ]
      }
    },

    created () {
        
    },

    methods: {

      getIdCardTypes () {
        this.processing = true
        this.axios.get(this.config.apis.getIdCardTypes)
        .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.idCardTypes = response.data.data
            }
        })
        .catch((error) => {
            this.processing = false
        })
      },

      getCities (state) {
        this.processing = true
        this.cities = []
        this.axios.get(this.config.apis.getCitiesByState.replace(":state", state))
        .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.cities = response.data.data
            }
        })
        .catch((error) => {
            this.processing = false
        })
      },

      upsertItem () {

        let is_update = !!this.item.id,
            api_path = this.config.apis.addAgent + (is_update ? `/${this.item.id}` : ""),
            method = is_update ? "put" : "post"

        this.processing = true

        this.axios[method](api_path, this.item)
          .then((response) => {
            if (this.isSuccessResponse(response)) {
              
              let item = this.extend({}, this.item)
              item.id = response.data.data.id

              let country = this.countries.filter( v => v.id == item.country )

              item.country_name = country ? country[0].country : ""

              let state = this.states.filter( v => v.id == item.state )

              item.state_name = state ? state[0].state : ""

              let city = this.cities.filter( v => v.id == item.city )

              item.city_name = city ? city[0].city : ""

              this.notifySuccess(is_update ? 'updateSuccess' : 'insertSuccess')
              this.close()

              this.$emit('success', item)
            }
            else{
              this.notifyError(is_update ? 'updateError' : 'insertError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      close () {
        this.dialog = false
        this.$emit('update:active', this.dialog)
        setTimeout(() => {
          this.item = this.extend({}, this.defaultItem)
          this.$emit('update:editingItem', null)
        }, 300)
      }

    },

    mounted () {
      this.getCountries()
      this.getIdCardTypes()
      this.item = this.extend({}, this.defaultItem)
    },

    computed: {

    },

    components: {
      
    },

    watch: {

      'item.country': function(val, oldVal){
          if (val && val != oldVal) {
              this.getStatesByCountry(val).then( states => {
                this.states = states
              })
          }
      },

      'item.state': function(val, oldVal){
          if (val && val != oldVal) {
              this.getCities(val)
          }
      },

      editingItem (val, oldVal) {
        if (val && val !== oldVal && typeof val === 'object') {
          this.item = this.extend({}, val)
        }
      },

      active (val, oldVal) {
        this.dialog = val
      },

      dialog (val, oldVal) {
        if (val === false) {
          this.close()
        }
      }

    }

  }

</script>
